import React, { useEffect, useState } from "react";
import { fetchCurrentUser } from "../utils/auth";
import Sidebar from "../components/Nav/AdminSidebar";

export default function Dashboard() {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const checkUser = async () => {
      const user = await fetchCurrentUser();
      if (!user.loggedIn) {
        console.warn("User not logged in");
        // Add redirect logic if you want here
      } else {
        setCurrentUser(user);
      }
    };

    checkUser();
  }, []);

  if (!currentUser) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-gray-400 text-lg">Loading user info...</p>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Sidebar fixed width */}
      <Sidebar />

      {/* Main content area */}
      <main className="flex-1 p-8">
        <h1 className="text-3xl font-extrabold mb-6 text-gray-900">
          Welcome, {currentUser.username}
        </h1>

        <div className="bg-white rounded-lg shadow p-6 max-w-xl">
          <p className="text-lg mb-4">
            Your Role ID:{" "}
            <span className="font-semibold">{currentUser.role_id}</span>
          </p>

          {currentUser.role_id === 1 && (
            <p className="text-green-600 font-medium">You are an Admin</p>
          )}
          {currentUser.role_id === 2 && (
            <p className="text-blue-600 font-medium">You are an Owner</p>
          )}
          {currentUser.role_id === 3 && (
            <p className="text-purple-600 font-medium">You are a Customer</p>
          )}
        </div>
      </main>
    </div>
  );
}
